var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCsv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.208 0c.16 0 .29.13.292.29v4.96a2.917 2.917 0 0 0 2.917 2.917h4.958c.16 0 .29.129.292.289v17.21A2.333 2.333 0 0 1 21.333 28H2.667a2.333 2.333 0 0 1-2.334-2.333V2.333A2.333 2.333 0 0 1 2.667 0zm1.64.432a.292.292 0 0 1 .317.064l6.008 6.006a.292.292 0 0 1-.206.498h-4.55a1.75 1.75 0 0 1-1.75-1.75V.7c0-.118.072-.223.18-.268z",
    fill: "#161038"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "IBMPlexMono-Bold, IBM Plex Mono",
    fontSize: 9,
    fontWeight: "bold",
    fill: "#FFF",
    transform: "translate(.333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3.667,
    y: 23
  }, "CSV")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.f34ded203165c76a6c8d866729197c56.svg";
export { ForwardRef as ReactComponent };